import React, { Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Confirmation } from "components/account-actions/confirmation/confirmation";
import { ResetPassword } from "components/account-actions/reset-password/reset-password";
import { Login } from "components/account-actions/login/login";
import { Logout } from "components/logout/logout";
import Loader from "components/shared-ui/loader";
import SnackBar from "components/shared-ui/snackBar/snackBar";
import {
  ACCESS_CREDENTIALS_ROUTE,
  ARCHIVE_ROUTE,
  BUCKETS_ROUTE,
  CONFIRMATION_ENTERPRISE_ROUTE,
  CONFIRMATION_ROUTE,
  DASHBOARD_ROUTE,
  DefaultRouteParam,
  ENTERPRISE_ACCOUNT_SETUP_ROUTE,
  getAbsoluteRoute,
  GROUPS_ROUTE,
  LOGIN_ROUTE,
  LOGOUT_ROUTE,
  LOGOUT_SUCCESS_ROUTE,
  POLICIES_ROUTE,
  RESET_PASSWORD_ROUTE,
  SETTINGS_ROUTE,
  SHARD_CLUSTERS_ROUTE,
  SHARD_REPOSITORIES_ROUTE,
  STORAGE_PROVIDERS_ROUTE,
  USERS_ROUTE,
} from "./constants/routes";
import { ConfirmationEnterprise } from "components/account-actions/confirmation-enterprise/confirmation-enterprise";
import LogoutSuccessPage from "components/logout/logout-success-page/logout-success-page";
import Dashboard from "components/dashboard/dashboard";
import ShardRepositories from "components/shard-repositories/shard-repositories";
import AccessCredentials from "components/access-credentials/access-credentials";
import SettingsV2 from "components/settings/settings";
import Buckets from "components/buckets/buckets";
import { ShardClusters } from "components/shard-clusters/shard-clusters";
import {
  EnterpriseAccountSetupLayout,
  MainLayout,
} from "components/layout/layout";
import { RequireAuth } from "components/layout/require-auth";
import IAMUsers from "components/iam-users/user";
import IAMGroups from "components/iam-groups/group";
import IAMPolicy from "components/iam-policies/policy";
import { StorageProviders } from "components/storage-providers/storage-providers";
import Archive from "components/archive/archive";

function App() {
  return (
    <>
      <SnackBar />

      <BrowserRouter>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path={LOGIN_ROUTE} element={<Login />} />
            <Route path={LOGOUT_ROUTE} element={<Logout />} />
            <Route
              path={LOGOUT_SUCCESS_ROUTE}
              element={<LogoutSuccessPage />}
            />
            <Route path={CONFIRMATION_ROUTE} element={<Confirmation />} />
            <Route
              path={CONFIRMATION_ENTERPRISE_ROUTE}
              element={<ConfirmationEnterprise />}
            />
            <Route path={RESET_PASSWORD_ROUTE} element={<ResetPassword />} />

            <Route
              path={ENTERPRISE_ACCOUNT_SETUP_ROUTE}
              element={<EnterpriseAccountSetupLayout />}
            />

            <Route
              path="/*"
              element={
                <RequireAuth redirectTo={LOGIN_ROUTE}>
                  <MainLayout />
                </RequireAuth>
              }
            >
              <Route
                path={`${ACCESS_CREDENTIALS_ROUTE}/:${DefaultRouteParam.IdOrAction}?`}
                element={<AccessCredentials />}
              />

              {/* <Route
                                path={`${SHARD_CLUSTERS_ROUTE}/:${DefaultRouteParam.IdOrAction}?`}
                                element={<ShardClusters />}
                                /> */}
              <Route
                path={`${STORAGE_PROVIDERS_ROUTE}/:${DefaultRouteParam.IdOrAction}?`}
                element={<StorageProviders />}
              />

              <Route
                path={`${SHARD_REPOSITORIES_ROUTE}/:${DefaultRouteParam.IdOrAction}?`}
                element={<ShardRepositories />}
              />

              <Route path={`${SETTINGS_ROUTE}`} element={<SettingsV2 />} />

              <Route
                path={`${USERS_ROUTE}/:${DefaultRouteParam.IdOrAction}?`}
                element={<IAMUsers />}
              />
              <Route
                path={`${GROUPS_ROUTE}/:${DefaultRouteParam.IdOrAction}?`}
                element={<IAMGroups />}
              />
              <Route
                path={`${POLICIES_ROUTE}/:${DefaultRouteParam.IdOrAction}?`}
                element={<IAMPolicy />}
              />
              <Route path={`${ARCHIVE_ROUTE}`} element={<Archive />} />

              <Route
                path={`${BUCKETS_ROUTE}/:${DefaultRouteParam.IdOrAction}?`}
                element={<Buckets />}
              />
              <Route
                path={`*`}
                element={<Navigate to={getAbsoluteRoute(BUCKETS_ROUTE)} />}
              />
              {/* <Route path={DASHBOARD_ROUTE} element={<Dashboard />} /> */}
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
}
export default App;
